import { render, staticRenderFns } from "./ProBadge.vue?vue&type=template&id=c63a01b8&scoped=true"
import script from "./ProBadge.vue?vue&type=script&lang=ts"
export * from "./ProBadge.vue?vue&type=script&lang=ts"
import style0 from "./ProBadge.vue?vue&type=style&index=0&id=c63a01b8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63a01b8",
  null
  
)

export default component.exports